import React from 'react';
import TimeAgo from 'react-timeago';
import moment from 'moment';
import { DEFAULT_AVATAR } from '@gtintel/platform-constants';
import { ProjectActivityType } from '@gtintel/platform-types';
import * as S from './styles';
const {
  PROJECT_CREATED,
  PROJECT_NEW_MEMBER,
  PROJECT_REMOVE_MEMBER
} = ProjectActivityType;
const renderUserName = ({
  full_name,
  is_active
}) => {
  return is_active ? <S.UserName>{full_name}</S.UserName> : <>
      <S.UserName deactivated>{full_name}</S.UserName>
      &nbsp;
      <S.DeactivatedLabel>(Deactivated account)</S.DeactivatedLabel>
    </>;
};
const renderActivityDescription = activity => {
  const action = Number(activity.action);
  if (action === PROJECT_NEW_MEMBER || action === PROJECT_REMOVE_MEMBER) {
    const who = renderUserName(activity.action_target);
    const what = action === PROJECT_REMOVE_MEMBER ? 'removed from' : 'added to';
    if (activity.user) {
      const whoElse = renderUserName(activity.user);
      return <>
          {who} was {what} the project by {whoElse}
        </>;
    }
    return <>
        {who} was {what} the project
      </>;
  }
  if (action === PROJECT_CREATED) {
    if (activity.user) {
      return <>Project created by {renderUserName(activity.user)}</>;
    }
    return <>Project created</>;
  }
  return <span>{activity.action_display}</span>;
};
const Activity = ({
  activity
}) => <S.Container data-testid="activity-tab">
    <S.ContentDiv>
      <S.AvatarDiv>
        <S.AvatarCustom src={activity.user?.avatar ?? DEFAULT_AVATAR} />
      </S.AvatarDiv>
      <S.TitleDiv>{renderActivityDescription(activity)}</S.TitleDiv>
    </S.ContentDiv>
    <S.TimeDiv title={moment(activity.action_date).format('MMMM Do YYYY, h:mm:ss a')}>
      <S.DisableHoverContainer>
        <TimeAgo date={activity.action_date} />
      </S.DisableHoverContainer>
    </S.TimeDiv>
  </S.Container>;
export default Activity;